import { useEffect, useState, useCallback } from "react";
import { detectInitialRegion, persistRegion, type Region } from "@/lib/region";

const EVT = "gaonova:region-changed";

export function useRegion() {
  const [region, setRegionState] = useState<Region>(() => detectInitialRegion());

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<Region>).detail;
      if (detail) setRegionState(detail);
    };
    window.addEventListener(EVT, handler);
    return () => window.removeEventListener(EVT, handler);
  }, []);

  const setRegion = useCallback((r: Region) => {
    persistRegion(r);
    setRegionState(r);
    window.dispatchEvent(new CustomEvent(EVT, { detail: r }));
  }, []);

  return { region, setRegion };
}
